import {ISearchEpgItem} from "../../../../interfaces/ISearchEpgItem.ts";
import {IChannel} from "../../../../interfaces/IChannel.ts";
import DateHelper from "../../../../helpers/dateHelper.ts";

interface IProps {
    item: ISearchEpgItem,
    channel?: IChannel
}

const AccountFavoritePreviousNextItem = ({item, channel}: IProps) => {
    return (
        <div className={'flex justify-between w-full items-center px-3 py-1.5 border-b border-neutral-600'}>
            <div className={"flex flex-col w-full"}>
                <div className={"flex justify-between w-full text-neutral-400 text-sm"}>
                    <time dateTime={DateHelper.DateTimeFromUnixTimestamp(item.time).toISOString()}>
                        {DateHelper.DateTimeFormatForEpgDetails(DateHelper.DateTimeFromUnixTimestamp(item.time))}
                    </time>
                    <span>
                        {channel?.name ?? ""}
                    </span>
                </div>
                <strong>
                    {item.name}
                </strong>
                {item.episode > 0 &&
                    <span className={"text-neutral-400 text-sm"}>
                        Odcinek {item.episode}
                    </span>
                }
            </div>
            {/*<div className={"flex"}>*/}
            {/*    <ChevronRightIcon className={"w-8 h-8 text-[#008dd2]"}/>*/}
            {/*</div>*/}
        </div>
    );
};

export default AccountFavoritePreviousNextItem;